import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "../../../../components/input";
import type { MerchantEditorFormValues } from "./merchant.scheme";

type MerchantFormProps = {
  values: MerchantEditorFormValues;
  onChange: (values: MerchantEditorFormValues) => void;
  disabled?: boolean;
};

const fieldClassName =
  "w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white";

const MerchantForm: React.FC<MerchantFormProps> = ({ values, onChange, disabled = false }) => {
  const { t } = useTranslation();

  const set =
    (key: keyof MerchantEditorFormValues) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange({ ...values, [key]: event.target.value });
    };

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <div className="flex flex-col gap-2">
        <label className="font-medium dark:text-white">{t("merchant.business_name")}</label>
        <Input
          name="business_name"
          value={values.business_name}
          onChange={set("business_name")}
          className="rounded-xl"
          disabled={disabled}
        />
        <label className="mt-3 font-medium dark:text-white">{t("merchant.short_intro")}</label>
        <Input
          name="short_intro"
          value={values.short_intro}
          onChange={set("short_intro")}
          className="rounded-xl"
          disabled={disabled}
        />
        <label className="mt-3 font-medium dark:text-white">{t("merchant.description")}</label>
        <textarea
          name="description"
          value={values.description}
          onChange={set("description")}
          className={fieldClassName}
          rows={4}
          disabled={disabled}
        />
      </div>
      <div className="flex flex-col gap-2">
        <label className="font-medium dark:text-white">{t("merchant.business_url")}</label>
        <Input
          name="business_url"
          value={values.business_url}
          onChange={set("business_url")}
          className="rounded-xl"
          disabled={disabled}
        />
        <label className="mt-3 font-medium dark:text-white">{t("merchant.phone")}</label>
        <Input
          name="phone"
          value={values.phone}
          onChange={set("phone")}
          className="rounded-xl"
          disabled={disabled}
        />
        <label className="mt-3 font-medium dark:text-white">{t("merchant.partner_type")}</label>
        <Input
          name="partner_type"
          value={values.partner_type}
          onChange={set("partner_type")}
          className="rounded-xl"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default MerchantForm;
